// import { UserProfileType } from 'types'
import { createStorage, validateToken } from "../utils";

class UserSession {
  token = createStorage<string>("access_token");

  checkUserLogin() {
    const storedTokenValue = this.token.get();

    // user have never logged in
    if (!storedTokenValue) return false;
    if (validateToken(storedTokenValue)) return true;
    /** remove the old token even if the token has been invalidated */
    this.token.remove();
    return false;
  }

  getToken() {
    return this.token.get();
  }

  logout() {
    this.token.remove();
  }

  login(token: string) {
    return this.token.set(token);
  }
}

export const AppUserSession = new UserSession();
